module.exports = __webpack_public_path__ + "static/media/landing.9168bf84.png";